import LineBreak from "components/LineBreak/LineBreak";
import { AddContactSVG, GreenTickSVG, RedCrossSVG } from "components/SVG/SVG";
import { useAppDispatch, useAppSelector } from "hooks/redux";
import React, { ChangeEvent, useState } from "react";
import { updateUserPhone } from "store/async-actions/Profile/profileAction";
import {
  countryCodeSelector,
  profileRespSelector,
} from "store/reducers/Profile/profile";
import "react-phone-input-2/lib/style.css";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";
import { CountryData } from "react-phone-input-2";

const ProfilePhone = () => {
  const profile = useAppSelector(profileRespSelector);

  const [enterPhone, setEnterPhone] = useState(false);

  const handleAddPhone = () => {
    setEnterPhone(true);
  };

  const handleClosePhone = () => {
    setEnterPhone(false);
  };

  const [phone, setPhone] = useState("");

  const [country, setCountry] = useState("");

  const handleChange = (value: string, country: CountryData) => {
    setPhone(value);
    setCountry(country.countryCode.toUpperCase());
  };

  const dispatch = useAppDispatch();

  const handleSavePhone = () => {
    dispatch(
      updateUserPhone({
        mobileNo: phone,
        countryCode: country,
      })
    );
    handleClosePhone();
    setCountry("");
    setPhone("");
  };

  return (
    <div>
      {!!profile?.phoneNo ? (
        <p>{profile?.phoneNo}</p>
      ) : (
        <div>
          <LineBreak />
          {enterPhone ? (
            <div className="link_edit_save_wrapper">
              {/* <input
                className="social_link_edit_input"
                placeholder="Enter Email"
                name="email"
                value={phone}
                onChange={handleChange}
              /> */}
              <PhoneInput
                country={(
                  localStorage.getItem("countryCode") || ""
                ).toLowerCase()} // Set the default country
                value={phone}
                onChange={handleChange}
                inputStyle={{
                  width: "100%",
                  outline: "none",
                  fontFamily: "IBM Plex Sans Condensed",
                  fontStyle: "normal",
                  fontSize: "14px",
                }}
              />
              <div className="sle_confirm_btns">
                <div onClick={handleSavePhone} className="pointer">
                  <GreenTickSVG />
                </div>
                <div onClick={handleClosePhone} className="pointer">
                  <RedCrossSVG />
                </div>
              </div>
            </div>
          ) : (
            <>
              <LineBreak />
              <div onClick={handleAddPhone} className="contact_empty_add">
                <AddContactSVG />
                <p>Add Phone</p>
              </div>
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default ProfilePhone;
